import * as Yup from 'yup';

import { CreateTreatyProgramAssociateDeductions, CreateTreatyProgramAssociateDeductionsVariables } from '_graphql/mutation/__generated__/CreateTreatyProgramAssociateDeductions';
import { Modal, OfficeButton } from 'components';

import { DeductionForm } from 'components/forms';
import { FC } from 'react'
import { LocationGenerics } from 'router/location';
import _ from 'lodash';
import { createAssociateDeduction } from '_graphql/visal/mutations/treaty-programs';
import moment from 'moment';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import { useMatch } from 'react-location';
import { useMutation } from '@apollo/client';
import { useTreatyProgram } from 'hooks/data/use-treaty-programs';
import { wrapClick } from 'utils';

type Props = {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}

const validationSchema = Yup.object().shape({
    deductions: Yup.object().shape({
        treaty_period_from: Yup.date().typeError("Provide a good format for the year YYYY").required("Period From is required"),
        treaty_period_to: Yup.date().typeError("Provide a good format for the year YYYY").required("Period To is required"),
        year: Yup.number().min(2019, "Year must be greater than 2019").max(moment().add(10, 'years').year(), "Year cannot be more than 10 years in the future").required("Year is required"),
        nic_levy: Yup.number().min(0, "Number must be greater than 0").typeError("Must be a number").required("NIC Levy is required"),
        withholding_tax: Yup.number().min(0, "Number must be greater than 0").typeError("Must be a number").required("Withholding Tax is required"),
        brokerage: Yup.number().min(0, "Number must be greater than 0").typeError("Must be a number").required("Brokerage is required"),
        commission: Yup.number().min(0, "Number must be greater than 0").typeError("Must be a number").required("Commission is required"),
        treaty_programstreaty_program_id: Yup.string().required("Treaty Program is required"),
    })
})

const CreateDeductionContainer: FC<Props> = ({ open, setOpen }) => {
    const { params } = useMatch<LocationGenerics>()
    const [initiate, { loading }] = useMutation<CreateTreatyProgramAssociateDeductions, CreateTreatyProgramAssociateDeductionsVariables>(createAssociateDeduction, {
        refetchQueries: ["GetTreatyProgramDeductions"]
    })
    const form = useFormik({
        initialValues: {
            deductions: {
                treaty_period_from: "",
                treaty_period_to: "",
                nic_levy: 0,
                withholding_tax: 0,
                brokerage: 0,
                commission: 0,
                treaty_programstreaty_program_id: params?.treaty_program || "",
                year: moment().year()
            }
        },
        validationSchema,
        onSubmit: (values) => {
            initiate({
                variables: {
                    deductions: _.omit(values.deductions, ["year"]),
                }
            }).then(({ data }) => {
                if (data?.createTreatyProgramAssociateDeductions) {
                    toast.success("Deduction added successfully")
                    setOpen(false)
                    form.resetForm();
                }
            }).catch(err => {
                toast.error(err.message)
            })
        }
    });

    const { treatyProgram, loading: fetching } = useTreatyProgram({
        programId: params?.treaty_program
    });

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            loading={fetching}
            size="4xl"
            title="Create New deduction"
            description="Provide the details to add a new deduction"
            renderActions={() => (
                <div className='ml-3'>
                    <OfficeButton onClick={wrapClick(form.handleSubmit)}>
                        {loading ? "Adding Deduction..." : "Add Deduction"}
                    </OfficeButton>
                </div>
            )}
        >
            <DeductionForm program={treatyProgram} form={form} />
        </Modal>
    )
}

export default CreateDeductionContainer